// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"b1f8becab82858146f9f","293":"cfc7670813e912931665","518":"329b1f725b890686fbf0","779":"a7bf2d3997ddc169101f"}[chunkId] + ".js";
};